// hooks/useAppAuth.js
import { useMemo } from "react";
import { useSelector } from "react-redux";

import { APPID } from '../common/constants';

export function useAppAuth() {
  const authState = useSelector((state) => state.authReducer);
  const userState = useSelector((state) => state.userReducer);
  const user = userState?.user;

  const isAuthed = useMemo(() => {
    if (!authState?.authenticated) return false;
    const roles = user?.userApplicationRoles || [];
    return roles.some((app) => app.application_id === APPID);
  }, [authState?.authenticated, user, APPID]);

  return { isAuthed, user, authState, userState };
}
